import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, Grid, Stack } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { Button, SubmitButton } from '../../../../../common/button';
import { SelectFieldFormik } from '../../../../../common/select_field';
import { GenerateWarehouseDocumentTypeRequestEnum } from '../../../../../../core/enums/inventory/warehouse_document';
import { getAllFoodPartnersState } from '../../../../../../features/food_partner/get_all_food_partners';
import { DateTimePickerFormik } from '../../../../../common/date_picker';
import { parseDateString } from '../../../../../../core/utils/date_utils';
import ThreeLevelSteps from '../../../../common/steps';
import { yesNoOptions } from '../../../../../common/form_utils';
import RadioGroupFormik from '../../../../../common/radio_group';
import { ROUTE_FOOD_PARTNER_ORDERS } from '../../../../../../core/constants';
import BottomActionBar from "../../../../../common/bottom_action_bar";
import SectionPaper from "../../../../../common/section_paper";

const GeneralDataForm = ({ form, onSubmitGeneralData }) => {
    const navigate = useNavigate();
    const getFoodPartners = useSelector(getAllFoodPartnersState);

    const initialValues = {
        foodPartnerId: form?.foodPartnerId || '',
        orderDate: form?.orderDate || '',
        locationDivision: form?.locationDivision || false
    };

    const schema = Yup.object().shape({
        foodPartnerId: Yup.number().when('type', {
            is: (type) => type === GenerateWarehouseDocumentTypeRequestEnum.MM_DOCUMENTS.value,
            then: Yup.number().notRequired(),
            otherwise: Yup.number().required()
        }),
        orderDate: Yup.date()
            .transform(parseDateString)
            .nullable()
            .required(),
        locationDivision: Yup.boolean()
            .required()
    });

    return (
        <Formik
            initialValues={ initialValues }
            validationSchema={ schema }
            validateOnChange={ false }
            validateOnBlur={ false }
            onSubmit={ onSubmitGeneralData }>
            { () => (
                <Box component={ Form } sx={ { display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 1 } }>
                    <Box sx={ { flexGrow: 1, pb: 4 } }>
                        <Stack spacing={ 3 }>
                            <ThreeLevelSteps firstStep/>

                            <SectionPaper title="Dane ogólne">
                                <Grid container spacing={ 3 }>
                                    <Grid item xs={ 12 } md={ 6 } lg={ 4 }>
                                        <SelectFieldFormik
                                            name="foodPartnerId"
                                            label="Dostawca"
                                            options={ getFoodPartners?.data?.map(getFoodPartner => ({
                                                value: getFoodPartner?.id,
                                                label: getFoodPartner?.name
                                            })) }
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={ 12 } md={ 6 } lg={ 4 }>
                                        <DateTimePickerFormik
                                            name="orderDate"
                                            label="Data zamówienia"
                                            required
                                            InputLabelProps={ { shrink: true } }
                                        />
                                    </Grid>
                                    <Grid item xs={ 12 } md={ 6 } lg={ 4 }>
                                        <RadioGroupFormik
                                            name="locationDivision"
                                            label="Podział na lokalizacje"
                                            options={ yesNoOptions }
                                        />
                                    </Grid>
                                </Grid>
                            </SectionPaper>
                        </Stack>
                    </Box>

                    <BottomActionBar>
                        <Box sx={ { display: 'flex', justifyContent: 'space-between', width: '100%' } }>
                            <Button variant="outlined"
                                    onClick={ () => navigate(ROUTE_FOOD_PARTNER_ORDERS) }>Wróć</Button>
                            <SubmitButton>Dalej</SubmitButton>
                        </Box>
                    </BottomActionBar>
                </Box>
            ) }
        </Formik>
    );
};

export default GeneralDataForm;